import { z } from "zod";

export const usersMeSettingsSchema = z.object({
  global: z.object({
    has_seen_sms_outside_hours_consent_popup: z.string().optional(),
    is_post_prayer_streak_enabled: z.string().optional(),
    tos_font_size: z
      .enum(["small", "medium", "large"])
      .optional()
      .default("medium"),
    tos_bg_color: z
      .enum(["content_color_hex", "system_theme"])
      .optional()
      .default("system_theme"),
    tos_default_auto_scroll: z
      .literal("false")
      .or(z.literal("true"))
      .nullable()
      .optional()
      .default("true"),
    had_has_seen_update_notice: z
      .literal("true")
      .nullable()
      .optional()
      .default(null),
    web_notification_opt_in: z
      .literal("true")
      .or(z.literal("false"))
      .nullable()
      .optional()
      .default("false"),
  }),
  per_community: z.object({}),
  per_device: z.object({}),
  per_user: z.object({}),
});

export type UsersMeSettingsSchema = z.infer<typeof usersMeSettingsSchema>;
